var _rect, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartsignLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#323D56"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 6 54 19 54 45 32 58 10 45 10 19 Z",
    fill: "#FFD400",
    stroke: "#FFD400",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20,19)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5 19 8.5 15 22 H9 L5 8.5 Z",
    fill: "#323D56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2.4,
    fill: "#FFD400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14.6 L12 22",
    stroke: "#FFD400",
    strokeWidth: 1.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartsignLogo);
export default __webpack_public_path__ + "static/media/smartsign-logo.0347d79349e15b696a30c76364279212.svg";
export { ForwardRef as ReactComponent };